module.exports = __webpack_public_path__ + "static/media/surveyQRCode.253c66ec.png";